<template>
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="7" cy="7" r="7" fill="#00E1A5"/>
<path d="M5.97485 9.61635L3.5 7.14145L4.32496 6.3165L5.97485 7.96645L9.27471 4.6666L10.0997 5.49156L5.97485 9.61635Z" fill="white"/>
</svg>
</template>
